export const policiesForInstituteNodes = [
  {
    value: "iv-policies-for-the-institute",
    label: "IV. Policies for the Institute of International Studies",
    className: "iv-policies-for-the-institute",
    children: [
      {
        value: "iv-policies-for-the-institute/a-academic-policies",
        label: "A. Academic Policies and Standards",
        className: "a-academic-policies",
        children: [
          {
            value:
              "iv-policies-for-the-institute/a-academic-policies/a-1-introduction",
            label: "A.1. Introduction",
            className: "a-1-introduction",
          },
          {
            value:
              "iv-policies-for-the-institute/a-academic-policies/a-2-academic-honesty",
            label: "A.2. Academic Honesty",
            className: "a-2-academic-honesty",
          },
          {
            value:
              "iv-policies-for-the-institute/a-academic-policies/a-3-academic-programs",
            label: "A.3. Academic Programs",
            className: "a-3-academic-programs",
          },
          {
            value:
              "iv-policies-for-the-institute/a-academic-policies/a-4-change-of-academic-program",
            label: "A.4. Change of Academic Program",
            className: "a-4-change-of-academic-program",
            children: [
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-4-change-of-academic-program/a-4-a-change-of-degree-program",
                label: "A.4.a. Change of Degree Program",
                className: "a-4-a-change-of-degree-program",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-4-change-of-academic-program/a-4-b-change-of-degree-program",
                label: "A.4.b. Admission to a Second Graduate Degree Program",
                className: "a-4-b-change-of-degree-program",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-4-change-of-academic-program/a-4-c-special-admission-and-registration-policies-for-non-degree-students",
                label:
                  "A.4.c. Special Admission and Registration Policies for Non-Degree Students",
                className:
                  "a-4-c-special-admission-and-registration-policies-for-non-degree-students",
              },
            ],
          },
          {
            value:
              "iv-policies-for-the-institute/a-academic-policies/a-5-instruction",
            label: "A.5. Instruction",
            className: "a-5-instruction",
            children: [
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-5-instruction/a-5-a-assessment-and-grading",
                label: "A.5.a. Assessment and Grading",
                className: "a-5-a-assessment-and-grading",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-5-instruction/a-5-b-course-syllabus",
                label: "A.5.b. Course Syllabus",
                className: "a-5-b-course-syllabus",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-5-instruction/a-5-c-student-grading-of-other-students-work",
                label: "A.5.c. Student Grading of Other Students' Work",
                className: "a-5-c-student-grading-of-other-students-work",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-5-instruction/a-5-d-external-study-and-study-abroad",
                label: "A.5.d. External Study and Study Abroad",
                className: "a-5-d-external-study-and-study-abroad",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-5-instruction/a-5-e-internships",
                label: "A.5.e. Internships",
                className: "a-5-e-internships",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-5-instruction/a-5-f-language-and-intercultural-competency-icc-requirements-at-the-middlebury-institute",
                label:
                  "A.5.f. Language and Intercultural Competency (ICC) Requirements at the Middlebury Institute",
                className:
                  "a-5-f-language-and-intercultural-competency-icc-requirements-at-the-middlebury-institute",
              },
            ],
          },
          {
            value:
              "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies",
            label: "A.6. Grades, Credits and Academic Policies",
            className: "a-6-grades-credits-and-academic-policies",
            children: [
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-a-grades-and-credits",
                label: "A.6.a. Grades and Credits",
                className: "a-6-a-grades-and-credits",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-b-disputed-academic-evaluation-procedures",
                label: "A.6.b. Disputed Academic Evaluation Procedures",
                className: "a-6-b-disputed-academic-evaluation-procedures",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-c-pass-no-pass-p-np-option",
                label: "A.6.c. Pass/No Pass (P/NP) Option",
                className: "a-6-c-pass-no-pass-p-np-option",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-d-pass-fail-p-f-option",
                label: "A.6.d. Pass/Fail (P/F) Option",
                className: "a-6-d-pass-fail-p-f-option",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-e-incomplete-grades",
                label: "A.6.e. Incomplete Grades",
                className: "a-6-e-incomplete-grades",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-f",
                label: 'A.6.f. Assignment of "In Progress"',
                className: "a-6-f",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-g-academic-standing",
                label: "A.6.g. Academic Standing",
                className: "a-6-g-academic-standing",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-h-academic-probation",
                label: "A.6.h. Academic Probation",
                className: "a-6-h-academic-probation",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-i-dismissal",
                label: "A.6.i. Dismissal",
                className: "a-6-i-dismissal",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-j-time-limit-for-completion-of-degree-requirements-currency",
                label:
                  "A.6.j. Time Limit for Completion of Degree Requirements (Currency)",
                className:
                  "a-6-j-time-limit-for-completion-of-degree-requirements-currency",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-k-petition-for-waiver-of-academic-regulations",
                label: "A.6.k. Petition for Waiver of Academic Regulations",
                className: "a-6-k-petition-for-waiver-of-academic-regulations",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-l-transfer-of-academic-credit-from-other-institutions",
                label:
                  "A.6.l. Transfer of Academic Credit from Other Institutions",
                className:
                  "a-6-l-transfer-of-academic-credit-from-other-institutions",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-m-challenge-examinations",
                label: "A.6.m. Challenge Examinations",
                className: "a-6-m-challenge-examinations",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-n-graduation-with-honors",
                label: "A.6.n. Graduation with Honors",
                className: "a-6-n-graduation-with-honors",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-6-grades-credits-and-academic-policies/a-6-o-attendance",
                label: "A.6.o. Attendance",
                className: "a-6-o-attendance",
              },
            ],
          },
          {
            value:
              "iv-policies-for-the-institute/a-academic-policies/a-7-policies-concerning-enrollment-and-payment-fees",
            label: "A.7. Policies Concerning Enrollment and Payment Fees",
            className: "a-7-policies-concerning-enrollment-and-payment-fees",
            children: [
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-7-policies-concerning-enrollment-and-payment-fees/a-7-a-full-time-and-part-time-enrollment-status",
                label: "A.7.a Full-Time and Part-Time Enrollment Status",
                className: "a-7-a-full-time-and-part-time-enrollment-status",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-7-policies-concerning-enrollment-and-payment-fees/a-7-b-payment-of-fees",
                label: "A.7.b. Payment of Fees",
                className: "a-7-b-payment-of-fees",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-7-policies-concerning-enrollment-and-payment-fees/a-7-c-tuition-refunds",
                label: "A.7.c. Tuition Refunds",
                className: "a-7-c-tuition-refunds",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-7-policies-concerning-enrollment-and-payment-fees/a-7-d-course-load-and-overloads",
                label: "A.7.d. Course Load and Overloads",
                className: "a-7-d-course-load-and-overloads",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-7-policies-concerning-enrollment-and-payment-fees/a-7-e-adding-courses",
                label: "A.7.e. Adding Courses",
                className: "a-7-e-adding-courses",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-7-policies-concerning-enrollment-and-payment-fees/a-7-f-dropping-courses",
                label: "A.7.f. Dropping Courses",
                className: "a-7-f-dropping-courses",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-7-policies-concerning-enrollment-and-payment-fees/a-7-f-auditing-courses",
                label: "A.7.g. Auditing Courses",
                className: "a-7-f-auditing-courses",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-7-policies-concerning-enrollment-and-payment-fees/a-7-g-repeating-courses",
                label: "A.7.h. Repeating Courses",
                className: "a-7-g-repeating-courses",
              },
            ],
          },
          {
            value:
              "iv-policies-for-the-institute/a-academic-policies/a-8-leaves-of-absence-withdrawal-suspension-expulsion-and-graduation",
            label:
              "A.8. Leaves of Absence, Withdrawal, Suspension, Expulsion, and Graduation",
            className:
              "a-8-leaves-of-absence-withdrawal-suspension-expulsion-and-graduation",
            children: [
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-8-leaves-of-absence-withdrawal-suspension-expulsion-and-graduation/a-8-a-leave-of-absence-student-initiated",
                label: "A.8.a. Leave of Absence - Student Initiated",
                className: "a-8-a-leave-of-absence-student-initiated",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-8-leaves-of-absence-withdrawal-suspension-expulsion-and-graduation/a-8-b-institute-initiated-leave-of-absence-emergency-withdrawal-suspension-or-expulsion",
                label:
                  "A.8.b. Institute Initiated Leave of Absence, Emergency Withdrawal, Suspension or Expulsion",
                className:
                  "a-8-b-institute-initiated-leave-of-absence-emergency-withdrawal-suspension-or-expulsion",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-8-leaves-of-absence-withdrawal-suspension-expulsion-and-graduation/a-8-c-graduation",
                label: "A.8.c. Graduation",
                className: "a-8-c-graduation",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-8-leaves-of-absence-withdrawal-suspension-expulsion-and-graduation/a-8-d-withdrawal-from-middlebury-institute",
                label: "A.8.d. Withdrawal from the Middlebury Institute",
                className: "a-8-d-withdrawal-from-middlebury-institute",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-8-leaves-of-absence-withdrawal-suspension-expulsion-and-graduation/a-8-e-readmission-to-the-middlebury-institute",
                label: "A.8.e. Readmission to the Middlebury Institute",
                className: "a-8-e-readmission-to-the-middlebury-institute",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-8-leaves-of-absence-withdrawal-suspension-expulsion-and-graduation/a-8-f-withdrawal-procedures",
                label:
                  "A.8.f. Withdrawal Procedures for Students Who Are Military Dependents Whose Families Must Move Due to Redeployment/Relocation",
                className: "a-8-f-withdrawal-procedures",
              },
              {
                value:
                  "iv-policies-for-the-institute/a-academic-policies/a-8-leaves-of-absence-withdrawal-suspension-expulsion-and-graduation/a-8-g",
                label: "A.8.g. Return of Title IV (Federal) Funds",
                className: "a-8-g",
              },
            ],
          },
        ],
      },
      {
        value:
          "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations",
        label:
          "B. Policies Governing Student Conduct and Student Organizations",
        className:
          "b-policies-governing-student-conduct-and-student-organizations",
        children: [
          {
            value:
              "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/a-general",
            label: "B.1. General Policies",
            className: "a-general",
          },
          {
            value:
              "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/b-conduct",
            label: "B.2. Conduct",
            className: "b-conduct",
            children: [
              {
                value:
                  "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/b-conduct/b-2-a-general-conduct-policy",
                label: "B.2.a. General Conduct Policy",
                className: "b-2-a-general-conduct-policy",
              },
              {
                value:
                  "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/b-conduct/b-2-c-student-conduct-policy-overview",
                label: "B.2.b. Student Conduct Policy Overview",
                className: "b-2-c-student-conduct-policy-overview",
              },
              {
                value:
                  "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/b-conduct/b-2-d-student-conduct-disciplinary-process",
                label: "B.2.c. Student Conduct Disciplinary Process",
                className: "b-2-d-student-conduct-disciplinary-process",
                children: [
                  {
                    value:
                      "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/b-conduct/b-2-d-student-conduct-disciplinary-process/a-overview",
                    label: "A. Overview",
                    className: "a-overview",
                  },
                  {
                    value:
                      "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/b-conduct/b-2-d-student-conduct-disciplinary-process/b-the-judicial-system",
                    label: "B. The Judicial System",
                    className: "b-the-judicial-system",
                  },
                  {
                    value:
                      "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/b-conduct/b-2-d-student-conduct-disciplinary-process/c-hearing-procedures",
                    label: "C. Hearing Procedures",
                    className: "c-hearing-procedures",
                  },
                  {
                    value:
                      "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/b-conduct/b-2-d-student-conduct-disciplinary-process/d-sanctions-for-general-non-academic-offenses",
                    label: "D. Sanctions for General Non-Academic Offenses",
                    className: "d-sanctions-for-general-non-academic-offenses",
                  },
                  {
                    value:
                      "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/b-conduct/b-2-d-student-conduct-disciplinary-process/e-sanctions-for-academic-offenses",
                    label: "E. Sanctions for Academic Offenses",
                    className: "e-sanctions-for-academic-offenses",
                  },
                  {
                    value:
                      "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/b-conduct/b-2-d-student-conduct-disciplinary-process/f-appeals-procedures",
                    label: "F. Appeals Procedures",
                    className: "f-appeals-procedures",
                  },
                ],
              },
            ],
          },
          {
            value:
              "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/c-health-wellness",
            label: "B.3. Health & Wellness",
            className: "c-health-wellness",
          },
          {
            value:
              "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/d-student-clubs-and-organizations",
            label: "B.4. Student Clubs and Organizations",
            className: "d-student-clubs-and-organizations",
            children: [
              {
                value:
                  "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/d-student-clubs-and-organizations/b-4-club-approval",
                label: "B.4.a. Start a Club",
                className: "b-4-club-approval",
              },
              {
                value:
                  "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/d-student-clubs-and-organizations/b-4-b-club-funding",
                label: "B.4.b. Club Funding",
                className: "b-4-b-club-funding",
              },
              {
                value:
                  "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/d-student-clubs-and-organizations/b-4-c-event-identification-policy",
                label: "B.4.c. Event Identification Policy",
                className: "b-4-c-event-identification-policy",
              },
              {
                value:
                  "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/d-student-clubs-and-organizations/b-4-d-alochol-policy-serving-alcohol-at-events",
                label: "B.4.d. Alcohol Policy (serving alcohol at events)",
                className: "b-4-d-alochol-policy-serving-alcohol-at-events",
              },
              {
                value:
                  "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/d-student-clubs-and-organizations/b-4-e-guest-policy",
                label: "B.4.e. Guest Policy for Events",
                className: "b-4-e-guest-policy",
              },
              {
                value:
                  "iv-policies-for-the-institute/b-policies-governing-student-conduct-and-student-organizations/d-student-clubs-and-organizations/b-4-f-food-and-beverage-policy",
                label: "B.4.f. Food and Beverage Policy",
                className: "b-4-f-food-and-beverage-policy",
              },
            ],
          },
        ],
      },
      {
        value: "iv-policies-for-the-institute/c-faculty-handbook",
        label: "C. Faculty Handbook",
        className: "c-faculty-handbook",
        children: [
          {
            value:
              "iv-policies-for-the-institute/c-faculty-handbook/1-introduction",
            label: "C.1. Introduction",
            className: "1-introduction",
          },
          {
            value:
              "iv-policies-for-the-institute/c-faculty-handbook/2-administrative-roles",
            label: "C.2. Administrative Roles",
            className: "2-administrative-roles",
          },
          {
            value:
              "iv-policies-for-the-institute/c-faculty-handbook/3-faculty-roles",
            label: "C.3. Faculty Roles",
            className: "3-faculty-roles",
          },
          {
            value:
              "iv-policies-for-the-institute/c-faculty-handbook/4-faculty-organization-and-governance",
            label: "C.4. Faculty Organization and Governance",
            className: "4-faculty-organization-and-governance",
          },
          {
            value:
              "iv-policies-for-the-institute/c-faculty-handbook/5-policies-and-procedures-for-members-of-the-faculty",
            label: "C.5. Policies and Procedures for Members of the Faculty",
            className: "5-policies-and-procedures-for-members-of-the-faculty",
          },
          {
            value:
              "iv-policies-for-the-institute/c-faculty-handbook/6-evaluation-of-the-faculty",
            label: "C.6. Evaluation of the Faculty",
            className: "6-evaluation-of-the-faculty",
          },
          {
            value:
              "iv-policies-for-the-institute/c-faculty-handbook/7-separation-from-the-institute",
            label: "C.7. Separation from the Institute",
            className: "7-separation-from-the-institute",
          },
          {
            value:
              "iv-policies-for-the-institute/c-faculty-handbook/8-other-faculty-matters",
            label: "C.8. Other Faculty Matters",
            className: "8-other-faculty-matters",
          },
          {
            value:
              "iv-policies-for-the-institute/c-faculty-handbook/appendix-a-faculty-evaluation-schedule",
            label: "Appendix A: Faculty Evaluation Schedule",
            className: "appendix-a-faculty-evaluation-schedule",
          },
          {
            value:
              "iv-policies-for-the-institute/c-faculty-handbook/appendix-b-aaup-guidelines",
            label: "Appendix B: AAUP Guidelines",
            className: "appendix-b-aaup-guidelines",
          },
          {
            value:
              "iv-policies-for-the-institute/c-faculty-handbook/appendix-c-faculty-evaluation-calendar-by-semester",
            label: "Appendix C: Faculty Evaluation Calendar by Semester",
            className: "appendix-c-faculty-evaluation-calendar-by-semester",
          },
        ],
      },
      {
        value: "iv-policies-for-the-institute/d-employee-handbook",
        label: "D. Employee Handbook",
        className: "d-employee-handbook",
        children: [
          {
            value:
              "iv-policies-for-the-institute/d-employee-handbook/d-1-employment-policies-and-practices",
            label: "D.1. Employment Policies and Practices",
            className: "d-1-employment-policies-and-practices",
          },
          {
            value:
              "iv-policies-for-the-institute/d-employee-handbook/d-2-employee-relations",
            label: "D.2. Employee Relations",
            className: "d-2-employee-relations",
          },
          {
            value:
              "iv-policies-for-the-institute/d-employee-handbook/d-3-employee-benefits",
            label: "D.3. Employee Benefits",
            className: "d-3-employee-benefits",
          },
          {
            value:
              "iv-policies-for-the-institute/d-employee-handbook/d-4-employee-conduct",
            label: "D.4. Employee Conduct",
            className: "d-4-employee-conduct",
          },
          {
            value:
              "iv-policies-for-the-institute/d-employee-handbook/d-5-leaves-of-absence",
            label: "D.5. Leaves of Absence",
            className: "d-5-leaves-of-absence",
          },
          {
            value:
              "iv-policies-for-the-institute/d-employee-handbook/d-6-miscellaneous-considerations",
            label: "D.6. Miscellaneous Considerations",
            className: "d-6-miscellaneous-considerations",
          },
        ],
      },
    ],
  }
]